import calculatePriceValues, { type Price } from '../getPriceValues';
import roundToTwo from '../roundToTwo';
import strikeRulesFactory from '@spa/components/product-price/price-strike-rules';

type DiscountValueProduct = {
  readonly currentPrice: Price;
  readonly campaignPrice: Price | null;
  readonly strikePrice: Price | null;
  readonly recommendedRetailPrice: Price | null;
};

type CalculateDiscountValueType = {
  product: DiscountValueProduct;
  country: string;
};

export const calculateDiscountValue = (props: CalculateDiscountValueType): number | undefined => {
  const { product, country } = props;
  const { currentPrice, campaignPrice, strikePrice, recommendedRetailPrice } = product;

  const { currentPriceValue, campaignPriceValue, strikePriceValue, recommendedRetailPriceValue } =
    calculatePriceValues(false, {
      currentPrice,
      campaignPrice,
      strikePrice,
      recommendedRetailPrice
    });

  const strikeRules = strikeRulesFactory(country, {
    currentPriceValue,
    campaignPriceValue,
    strikePriceValue,
    recommendedRetailPriceValue
  });

  const strikePriceInfo = strikeRules.findStrikePriceInfo();
  const mainPriceValue = campaignPriceValue ?? currentPriceValue;
  const discount = strikePriceInfo
    ? roundToTwo(strikePriceInfo.priceValue - mainPriceValue)
    : undefined;

  return discount || undefined;
};
